import { render, staticRenderFns } from "./SnapIcon.vue?vue&type=template&id=8854ef18&"
import script from "./SnapIcon.vue?vue&type=script&lang=js&"
export * from "./SnapIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports